var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: _vm.pram.id ? "编辑商品频道" : "新增商品频道",
            top: "100px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "pram", attrs: { "label-width": "120px", model: _vm.pram } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "频道名称：",
                    prop: "channelName",
                    rules: [
                      {
                        required: true,
                        message: "请填写频道名称",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请填写频道名称" },
                    model: {
                      value: _vm.pram.channelName,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "channelName", $$v)
                      },
                      expression: "pram.channelName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "频道状态：",
                    prop: "status",
                    rules: [
                      {
                        required: true,
                        message: "请选择状态",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.pram.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "status", $$v)
                        },
                        expression: "pram.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("启用"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("禁用"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.miniProgramCustomer
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "开启线下支付",
                        prop: "isOfflinePayment",
                        rules: [
                          {
                            required: true,
                            message: "请选择是否开启线下支付",
                            trigger: ["blur", "change"],
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "small" },
                          model: {
                            value: _vm.pram.isOfflinePayment,
                            callback: function ($$v) {
                              _vm.$set(_vm.pram, "isOfflinePayment", $$v)
                            },
                            expression: "pram.isOfflinePayment",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v("开启"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v("关闭"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", [_vm._v("开启后，该频道福豆可用于线下支付")]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "备注：", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      resize: "none",
                      placeholder: "备注",
                    },
                    model: {
                      value: _vm.pram.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "remark", $$v)
                      },
                      expression: "pram.remark",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "图标名称：", prop: "status" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请填写" },
                    model: {
                      value: _vm.pram.iconName,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "iconName", $$v)
                      },
                      expression: "pram.iconName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "图标图标：", prop: "status" } },
                [
                  _vm.userType === 1
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "upLoadPicBox",
                              on: {
                                click: function ($event) {
                                  return _vm.modalPicTap("1", "iconImg")
                                },
                              },
                            },
                            [
                              _vm.pram.iconImg
                                ? _c("div", { staticClass: "pictrue" }, [
                                    _c("img", {
                                      attrs: { src: _vm.pram.iconImg },
                                    }),
                                  ])
                                : _c("div", { staticClass: "upLoad" }, [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-camera cameraIconfont",
                                    }),
                                  ]),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.pram.iconImg
                            ? _c("i", {
                                staticClass: "el-icon-delete",
                                staticStyle: {
                                  color: "red",
                                  "font-size": "16px",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeImg("iconImg")
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      )
                    : _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "avatar-uploader",
                              attrs: {
                                action: "",
                                "show-file-list": false,
                                "http-request": function (options) {
                                  return _vm.handleLocalUpload(
                                    options,
                                    "iconImg"
                                  )
                                },
                                "before-upload": _vm.beforeUpload,
                                accept: "image/*",
                              },
                            },
                            [
                              _vm.pram.iconImg
                                ? _c("img", {
                                    staticClass: "avatar",
                                    attrs: { src: _vm.pram.iconImg },
                                  })
                                : _c("i", {
                                    staticClass:
                                      "el-icon-plus avatar-uploader-icon",
                                  }),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.pram.iconImg
                            ? _c("i", {
                                staticClass: "el-icon-delete",
                                staticStyle: {
                                  color: "red",
                                  "font-size": "20px",
                                  "margin-left": "10px",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeImg("iconImg")
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "图标跳转链接：", prop: "status" } },
                [
                  _c("JumpNative", {
                    model: {
                      value: _vm.pram.iconUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "iconUrl", $$v)
                      },
                      expression: "pram.iconUrl",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "图标开启状态：", prop: "status" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.pram.iconStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "iconStatus", $$v)
                        },
                        expression: "pram.iconStatus",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("开启"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("关闭"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.handerSubmit("pram")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }